"use client";

import { formatScore, type Score } from "@/lib/chess/uci";
import { winPercent } from "@/lib/chess/winchance";

/** Vertical bar showing White's winning chances; White's share fills from White's side. */
export function EvalBar({ score, orientation = "white" }: { score: Score | null; orientation?: "white" | "black" }) {
  const w = score ? winPercent(score) : 50;
  const whiteAtBottom = orientation === "white";
  return (
    <div
      className="relative w-4 shrink-0 overflow-hidden rounded bg-[#2a221d] ring-1 ring-black/20 sm:w-5"
      role="meter"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(w)}
      aria-label={`Evaluation ${score ? formatScore(score) : "pending"}, White's winning chances ${Math.round(w)} percent`}
    >
      <div
        className="absolute inset-x-0 bg-[#f3ead8] transition-all duration-500"
        style={whiteAtBottom ? { bottom: 0, height: `${w}%` } : { top: 0, height: `${w}%` }}
      />
      <span
        className="absolute inset-x-0 text-center text-[9px] font-bold"
        style={{
          [w >= 50 === whiteAtBottom ? "bottom" : "top"]: 2,
          color: w >= 50 ? "#2a221d" : "#f3ead8",
        }}
      >
        {score ? formatScore(score).replace("+", "") : ""}
      </span>
    </div>
  );
}
